// 这里存放项目所需要的工具方法
import { MessageBox } from 'element-ui'
import store from '../store'

/**
 * js 对象浅拷贝
 * @param {object} obj
 * @return {object}
 * @public
 */
export function pureJsonClone(obj) {
  return JSON.parse(JSON.stringify(obj))
}

/**
 * 判断字段是否为非空值
 * @param {any} param
 * @return {Boolean}
 * @public
 */
export function hasValue(param) {
  if (Array.isArray(param)) {
    // 数组
    return param.length > 0
  }
  if (typeof param === 'object') {
    // object
    return Object.keys(param).length > 0
  }
  return param || param === 0 // string | number
}

/**
 * 移除js对象属性值为空的元素
 * 适用场景：服务端接口规定参数值为空时不传递该参数
 * @param {object} obj
 * @return {object}
 * @public
 */
export function removeObjEmptyProperty(obj) {
  for (let key in obj) {
    if (
      obj.hasOwnProperty(key) &&
      (obj[key] === null ||
        obj[key] === undefined ||
        obj[key] === '' ||
        (Array.isArray(obj[key]) && obj[key].length === 0))
    ) {
      delete obj[key]
    }
  }
  return obj
}

/**
 * 将unix时间戳转换为 年-月-日 时:分:秒
 * @param {number} timestamp
 * type: 0 年月日时分秒 1 时分秒
 * @return {string}
 * @public
 */
export function unixTimestamp(timestamp, type = 0) {
  timestamp = Number(timestamp)
  let date = new Date(timestamp)
  let Y = date.getFullYear()
  let M =
    date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  return type === 0 ? `${Y}-${M}-${D}  ${h}:${m}:${s}` : `${h}:${m}:${s}`
}

export function formnatUnixTimestampToHHmmss(timestamp) {
  timestamp = Number(timestamp)
  let date = new Date(timestamp)
  let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  return `${h}:${m}:${s}`
}

export function secondToDate(seconds) {
  let secondsN = Number(seconds)
  let h = Math.floor(secondsN / 3600)
  let m = Math.floor((secondsN / 60) % 60)
  let s = Math.floor(secondsN % 60)

  return `${h} 小时 ${m} 分钟 ${s} 秒`
}

/**
 * 格式化远程状态参数
 * 1、字段存在时，判断附加单位是否存在，存在则显示字段值加单位, 不存在则直接显示字段值
 * 2、字段不存在，显示 '-'
 * @param {object} obj
 * @param {string} param
 * @param {string} pend 附加单位参数
 *
 */
export function formatParam(obj, param, pend) {
  if (obj.hasOwnProperty(param)) {
    return pend ? obj[param] + ' ' + pend : obj[param]
  } else {
    return '-'
  }
}

/**
 * transformToQueryUrl: 将url转换成查询参数类型的url
 * @param url {string}
 * @param params {object}
 * @returns {string}
 */
export function transformToQueryUrl(url, params) {
  let query = ''
  if (params && Object.keys(params).length > 0) {
    query = '?'
    let count = 1
    for (let ele in params) {
      if (count < Object.keys(params).length) {
        query += ele + '=' + params[ele] + '&'
        count++
      } else {
        query += ele + '=' + params[ele]
      }
    }
  }
  return url + query
}

/**
 * 根据传入url及传递参数，跳转到对应的网页
 * @param {string} url 路径
 * @param {*} params 参数
 */
export function openUrl(url, params, target) {
  var el = document.createElement('a')
  document.body.appendChild(el)
  el.href = transformToQueryUrl(url, params)
  el.target = target ? '_self' : '_blank'

  var e = document.createEvent('MouseEvents')
  e.initEvent('click', true, true)
  el.dispatchEvent(e)
  document.body.removeChild(el)
}

/**
 * confirmPopover(): 确认提醒模态弹窗
 * @param type{String} 提示类型
 * @param contentText{String} 提示字段
 * @param successFn{Function} 成功回调
 * @param failFn{Function} 失败回调
 */
export function confirmPopover(type, contentText, successFn, failFn) {
  MessageBox.confirm(contentText, '温馨提示', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: type
  })
    .then(() => {
      successFn && successFn()
    })
    .catch(() => {
      failFn && failFn()
    })
}

export function changeInterToBinaryString(intNum) {
  return intNum ? parseInt(intNum).toString(2) : '0000'
}

/**
 * @method
 * @param {array} arr 需要查找的数组
 * @param {number} num 目标数值，查找的是与这个数值最接近的
 * @return {number} 返回查找到的最接近的数值
 * @return {number} 返回查找到的最接近数值的索引
 * @desc 获取数组中与目标数值最接近的数值及索引
 */

export function findCloseNumFromArr(arr, num) {
  let index = 0 // 保存最接近数值在数组中的索引
  let dValue = Number.MAX_VALUE // 保存差值绝对值，默认为最大数值
  for (let i = 0; i < arr.length; i++) {
    let newDvalue = Math.abs(arr[i] - num) // 新差值
    if (newDvalue <= dValue) {
      // 如果新差值绝对值小于等于旧差值绝对值，保存新差值绝对值和索引
      if (newDvalue === dValue && arr[i] < arr[index]) {
        // 如果数组中两个数值跟目标数值差值一样，取大
        continue
      }
      index = i
      dValue = newDvalue
    }
  }
  return {
    value: arr[index],
    index
  }
}

/**
 * 数组转字典
 */
export function arr2map(array, key) {
  const res = {}
  array.map((item) => {
    const keyVal = item[key]
    res[keyVal] = pureJsonClone(item)
  })
  return res
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a')
      return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return timeStr
}

/**
 * 判断用户是否有接口权限或其他权限
 * @param {string} url
 * @param {number} type 2--接口权限 3--其他权限
 */
export function hasAuth(url, type) {
  let hasAuth = false
  let authList = type === 2 ? store.state.userApi : store.state.userOtherAuth
  if (authList && authList.length > 0) {
    hasAuth = authList.some((item) => {
      return item.path === url
    })
  }
  return hasAuth
}

/**
 * 根据key返回映射值，不存在映射关系的返回key
 */
export function getMapValue(map, key) {
  if (map[key]) {
    return map[key]
  }
  return key
}

/**
 * 若url不是http协议，转换为https
 * @param {*} url
 * @returns
 */
export function changeHttpToHttps(url) {
  if (url.indexOf('https') === -1) {
    return url.replace('http', 'https')
  } else {
    return url
  }
}

export function copyText(text) {
  try {
    // text是复制文本
    // 创建input元素
    const el = document.createElement('input')
    // 给input元素赋值需要复制的文本
    el.setAttribute('value', text)
    // 将input元素插入页面
    document.body.appendChild(el)
    // 选中input元素的文本
    el.select()
    // 复制内容到剪贴板
    document.execCommand('copy')
    // 删除input元素
    document.body.removeChild(el)
  } catch (error) {
    console.log('copyText Error', error.message)
  }
}

export function showButton(string) {
  return !!store.state.userOtherAuth.some((user) => user.path == string)
}

export function scrollTop(elementId = 'page-container') {
  const timer = setTimeout(() => {
    clearTimeout(timer)
    document.getElementById(elementId).scrollTo(0, 0)
  }, 10)
}

export function mySetInterval(callback, delay) {
  let timerId

  function execute() {
    callback()
    timerId = setTimeout(execute, delay)
  }

  timerId = setTimeout(execute, delay)

  // 返回一个取消函数
  return () => {
    clearTimeout(timerId)
  }
}

/**
 * 将接口返回的文件流保存为本地文件（浏览器端）
 * @param {Object} response - axios 或其他请求库的响应对象
 * @param {Blob|ArrayBuffer} response.data - 文件流数据
 * @param {Object} response.headers - 响应头（如 {'content-disposition': '...'}）
 * @param {string} [defaultFileName='download.file'] - 无 Content-Disposition 时的默认文件名
 * @returns {Promise<void>}
 */
export async function downloadFile(
  response,
  defaultFileName = 'download.file'
) {
  const { data, headers } = response

  // 1. 确保拿到 Blob 对象
  let blob
  if (data instanceof Blob) {
    blob = data
  } else if (data instanceof ArrayBuffer) {
    blob = new Blob([data], { type: 'application/octet-stream' })
  } else {
    throw new Error('数据格式错误')
  }

  // 2. 从响应头解析文件名
  let fileName = defaultFileName
  const disposition =
    headers['content-disposition'] || headers['Content-Disposition']
  if (disposition) {
    // 匹配 filename*=UTF-8''xxx 或 filename="xxx" 或 filename=xxx
    const match = disposition.match(
      /filename\*?=(?:UTF-8'')?["']?([^;"']*)["']?/i
    )
    if (match && match[1]) {
      fileName = decodeURIComponent(match[1])
    }
  }

  // 3. 创建临时链接并触发下载
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()

  // 4. 清理内存
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}
